import React, { Component } from "react";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import _ from "lodash";

import {
  Pivot,
  PivotItem,
  PivotLinkSize
} from "office-ui-fabric-react/lib/Pivot";

class ShipmentDetailsPanel extends Component {
  render() {
    const itemsByCountry = _.chain(this.props.items)
      .groupBy("countryByCountryId.name")
      .map((value, key) => {
        return {
          country: key,
          boxes: _.sumBy(value, "boxes"),
          brutto: _.sumBy(value, "brutto"),
          pallets: _.sumBy(value, "amountPallets").toFixed(2)
        };
      })
      .value();

    const itemsByPacking = _.chain(this.props.items)
      .groupBy("packingTypeByPackingId.type")
      .map((value, key) => {
        return {
          type: key,
          colli: _.sumBy(value, "boxes"),
          pallets: _.sumBy(value, "amountPallets").toFixed(2)
        };
      })
      .value();

    const itemsByCountrySelected = _.chain(this.props.selectedItems)
      .groupBy("countryByCountryId.name")
      .map((value, key) => {
        return {
          country: key,
          boxes: _.sumBy(value, "boxes"),
          brutto: _.sumBy(value, "brutto"),
          pallets: _.sumBy(value, "amountPallets").toFixed(2)
        };
      })
      .value();

    const itemsByPackingSelected = _.chain(this.props.selectedItems)
      .groupBy("packingTypeByPackingId.type")
      .map((value, key) => {
        return {
          type: key,
          colli: _.sumBy(value, "boxes"),
          pallets: _.sumBy(value, "amountPallets").toFixed(2)
        };
      })
      .value();

    return (
      <Box mt={-1} style={{ fontSize: "small" }}>
        <Pivot linkSize={PivotLinkSize.normal}>
          <PivotItem linkText="Summary">
            <Box flex ml={1} mt={1}>
              <Box column>
                <Box>{`Boxes: ${_.sumBy(this.props.items, "boxes")}`} </Box>
                <Box> {`Brutto: ${_.sumBy(this.props.items, "brutto")}`} </Box>
                <Box>
                  {`Pallets: ${_.sumBy(
                    this.props.items,
                    "amountPallets"
                  ).toFixed(2)}`}{" "}
                </Box>
              </Box>
              <Box ml={2}>
                {itemsByPacking &&
                  itemsByPacking.map((item, key) => (
                    <div key={key}>
                      {`${item.type}  ${item.colli} st, ${
                        item.pallets
                      } pallets`}{" "}
                    </div>
                  ))}
              </Box>
            </Box>
          </PivotItem>

          <PivotItem linkText={`Selected ${this.props.selectedItems.length}`}>
            <Box flex ml={1} mt={1}>
              <Box column>
                <Box>
                  {`Boxes: ${_.sumBy(this.props.selectedItems, "boxes")}`}{" "}
                </Box>
                <Box>
                  {`Brutto: ${_.sumBy(this.props.selectedItems, "brutto")}`}{" "}
                </Box>
                <Box>
                  {`Pallets: ${_.sumBy(
                    this.props.selectedItems,
                    "amountPallets"
                  ).toFixed(2)}`}{" "}
                </Box>
              </Box>
              <Box ml={2}>
                {itemsByPackingSelected &&
                  itemsByPackingSelected.map((item, key) => (
                    <div key={key}>
                      {`${item.type}  ${item.colli} st, ${
                        item.pallets
                      } pallets`}{" "}
                    </div>
                  ))}
              </Box>
            </Box>
          </PivotItem>
          <PivotItem linkText="Origin">
            <Box flex ml={1} mt={1}>
              <Box>
                {itemsByCountry &&
                  itemsByCountry.map((item, key) => (
                    <div key={key}>
                      {item.country + ":" + item.boxes + "-" + item.brutto}
                    </div>
                  ))}
              </Box>
              <Box ml={1}>
                {itemsByCountrySelected &&
                  itemsByCountrySelected.map((item, key) => (
                    <div key={key}>
                      {item.country + ":" + item.boxes + "-" + item.brutto}
                    </div>
                  ))}
              </Box>
            </Box>
          </PivotItem>
        </Pivot>
      </Box>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(ShipmentDetailsPanel);



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentDetailsPanel.js